import React, { useRef, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';
import { proofCategories, salesProofs } from '../data/salesProofs';
import { SalesProofCard } from '../components/SalesProofCard';
import { SalesProofViewer } from '../components/SalesProofViewer';

export default function SalesProof() {
  const [category, setCategory] = useState('all');
  const [selectedProof, setSelectedProof] = useState(null);
  const returnFocusRef = useRef(null);
  const visibleProofs = salesProofs.filter((proof) => category === 'all' || proof.category === category);
  const openProof = (proof, event) => {
    returnFocusRef.current = event.currentTarget;
    setSelectedProof(proof);
  };

  return (
    <main className="min-h-screen pt-20" data-testid="salesproof-page">
      <section className="bg-gradient-to-br from-[#0D234E] to-[#1a3a6e] py-16 sm:py-20 text-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 text-center">
          <p className="mb-4 text-sm font-semibold uppercase text-[#BFB47E]" data-testid="salesproof-eyebrow">Sales Proof</p>
          <h1 className="mb-6 text-4xl sm:text-5xl lg:text-6xl font-bold" data-testid="salesproof-heading">Proven Results That Speak</h1>
          <p className="text-base leading-relaxed text-gray-200" data-testid="salesproof-intro">Shopify sales, Amazon KDP royalties, and Amazon Ads performance, with the original screenshots.</p>
        </div>
      </section>

      <section className="bg-white py-12 sm:py-16" aria-label="Sales proof gallery">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-6 flex flex-wrap gap-3" role="group" aria-label="Filter sales proof" data-testid="salesproof-filters">
            {proofCategories.map((item) => {
              const count = salesProofs.filter((proof) => item.id === 'all' || proof.category === item.id).length;
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setCategory(item.id)}
                  aria-pressed={category === item.id}
                  className={`inline-flex items-center gap-2 rounded-md border px-4 py-2.5 text-sm font-semibold transition-colors ${category === item.id ? 'border-[#0D234E] bg-[#0D234E] text-white' : 'border-gray-200 bg-white text-[#0D234E] hover:bg-gray-50'}`}
                  data-testid={`salesproof-filter-${item.id}`}
                >
                  {item.label} <span className="opacity-75" data-testid={`salesproof-filter-count-${item.id}`}>{count}</span>
                </button>
              );
            })}
          </div>
          <p className="mb-8 text-sm text-gray-600" role="status" data-testid="salesproof-results-count">{visibleProofs.length} {visibleProofs.length === 1 ? 'result' : 'results'}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" data-testid="salesproof-gallery">
            {visibleProofs.map((proof) => <SalesProofCard key={proof.id} proof={proof} onView={openProof} />)}
          </div>
        </div>
      </section>

      <section className="bg-gray-50 py-16 px-4 text-center">
        <h2 className="text-base md:text-lg font-bold text-[#0D234E]" data-testid="salesproof-contact-title">Let's build your next success story.</h2>
        <a href={contactInfo.whatsapp} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center justify-center gap-2 rounded-md bg-[#0D234E] px-6 py-3 font-semibold text-white transition-colors hover:bg-[#1a3a6e]" data-testid="salesproof-contact-whatsapp">
          <MessageCircle size={18} aria-hidden="true" /> Book a Call
        </a>
      </section>
      <SalesProofViewer proof={selectedProof} onClose={() => setSelectedProof(null)} returnFocusRef={returnFocusRef} />
    </main>
  );
}